
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[...param]",
      function () {
        return require("private-next-pages/product/[...param].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[...param]"])
      });
    }
  